import React from 'react'
import PropTypes from 'prop-types'
import ReactSVG from 'react-svg'

import styles from '../payment.css'

import checkedIcon from '../../../../../../images/checkbox-checked.svg'

const CheckedIcon = ({ onClick }) => {
  return (
    <div className={styles.checkbox} onClick={onClick}>
      <ReactSVG
        src={checkedIcon}
      />
    </div>
  )
}

CheckedIcon.propTypes = {
  onClick: PropTypes.func
}

CheckedIcon.defaultProps = {
  onClick: () => {}
}

export default CheckedIcon
